<template>
    <section>
        <div style="margin: 0" v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
            <div class="sk-bounce1"></div>
            <div class="sk-bounce2"></div>
            <div class="sk-bounce3"></div>
        </div>
        <div class="form-group">
            <label>City</label>
            <multiselect v-model="city" id="city" :disabled="disableField || isBranchUser" deselect-label="Can't remove this value" :allow-empty="false" :options="cities" track-by="city" label="city" @input="getAreasOfCity()"></multiselect>
        </div>
        <div class="form-group">
            <label>Area</label>
            <multiselect v-model="area"
            id="area"
            deselect-label="Can't remove this value"
            :allow-empty="false"
            :options="areasWithoutBanchArea"
            track-by="name"
            label="name"
            @search-change="getSeaarchedList"
            :disabled="disableField || isBranchUser"
            ></multiselect>
        </div>
    </section>
</template>

<script>
    /* eslint-disable */
    import Multiselect from 'vue-multiselect'
    export default {
        name: "CitiesAndAreas",
        components: { Multiselect },
        data: function() {
            return {
                selectedCity: "",
                selectedArea: "",
                city:"",
                area:"",
                cities: [],
                areas: [],
                isHideSpinner: "hide",
                isBranchArea:false,
                userRole:'',
                disableField: false
            };
        },
        props:['isAddingNewCustomer'],
        computed:{
            areasWithoutBanchArea () {
                if(this.isAddingNewCustomer){
                   return this.areas.filter(area => {
                        return area.isBranch===false;
                    });                    
                }else{
                    return this.areas.filter(area => {
                        return area.isBranch===true;
                    }); 
                }
            },
          isBranchUser(){
            return this.$store.state.user.userRolesById[0].role === 'ROLE_BRANCH'
          }
        },
        created: function () {
            this.$http.post(this.$store.state.mainAppURL + "areas/get_all_cities").then(resp => {
              this.cities = resp.data;
            });
            let user = this.$store.state.user;
            this.userRole = user.userRolesById[0].role;
            if (this.userRole === 'ROLE_USER') {
              this.disableField = true;
            }
        },
        watch: {
            city: function() {
                this.city ? $('#city.multiselect__input').removeAttr("required","required") : $('#city.multiselect__input').attr("required", "");
            },
            area: function() {
                this.area ? $('#area.multiselect__input').removeAttr("required","required") : $('#area.multiselect__input').attr("required", "");
                (this.area!=="") && (this.selectedArea = this.area.id);
            },
            selectedCity: function() {
                !(this.city) && (this.city = this.cities.find(city => city.id === this.selectedCity))
            },
            selectedArea: function() {
                !(this.area) && (this.isBranchArea = true)
            }
        },
        mounted: function (){
            $('#city.multiselect__input').attr("required", "");
            $('#area.multiselect__input').attr("required", "");
        },
        methods: {
            getAreasOfCity: function () {
                (this.city) && (this.selectedCity = this.city.id);
                this.area = "";
                if(this.selectedCity === ""){
                    this.areas = [];
                    return;
                }
                this.isHideSpinner = "";
                let params = new URLSearchParams();
                params.append("city_id", this.selectedCity);
                if(!this.isAddingNewCustomer){
                    this.$http.post(this.$store.state.mainAppURL + "areas/get_all_areas_by_city", params).then(resp => {
                        this.areas = resp.data;
                        (this.isBranchArea) && (this.area = this.areas.find(area => area.id === this.selectedArea));                        
                    });
                }
                this.isHideSpinner = "hide";
            },
            resetData: function () {
                this.selectedCity = "";
                this.selectedArea = "";
                this.city="";
                this.area="";
            },
            getSeaarchedList: function(query) {
                if(query.length>0 && this.city!==''){
                    let params = new URLSearchParams();
                    params.append("city_id", this.selectedCity);
                    params.append("area_query", query);

                    this.$http.post(this.$store.state.mainAppURL + "areas/get_all_filtered_areas", params).then(resp => {
                        console.log(resp.data);
                        this.areas= resp.data;
                    });
                }

            }
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
